import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-3 flex-grow-0 flex-shrink-1",staticStyle:{"display":"inline-block"}},[_c(VBtn,{attrs:{"color":"red","dark":"","x-small":"","fab":"","loading":_vm.loading},on:{"click":_vm.prev}},[_c(VIcon,[_vm._v("undo")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }